import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalSettings } from '../shared/domain/configuration.model';
import { AppConfigService } from '../shared/services/app-config.service';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService {
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    private crazyCallConfigService: CrazyCallConfigService
  ) {}

  getGlobalSettings(): Observable<GlobalSettings> {
    return this.http.get<GlobalSettings>(
      `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${this.crazyCallConfigService.appId}/global-settings`
    );
  }

  updateGlobalSettings(data: GlobalSettings): Observable<any> {
    return this.http.put(
      `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${this.crazyCallConfigService.appId}/global-settings`,
      data
    );
  }
}
